import { UIDS } from "../constants/constants";

const AES_KEY_BASE64 = UIDS?.slice(15, 59);
// const AES_KEY_BASE64 = process.env.REACT_APP_CKP_AESKEY;

/**
 * Base64 → Uint8Array
 */
function base64ToBytes(base64) {
  return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
}

/**
 * Decrypt encrypted payload from Spring Boot
 */
export async function decryptPayload(encryptedPayload) {
  // 1️⃣ Decode payload
  const encryptedBytes = base64ToBytes(encryptedPayload);

  // 2️⃣ Split IV and ciphertext
  const iv = encryptedBytes.slice(0, 12);      // ✅ 12‑byte IV
  const cipherText = encryptedBytes.slice(12); // ✅ encrypted data

  // 3️⃣ Import AES key
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    base64ToBytes(AES_KEY_BASE64),
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  // 4️⃣ Decrypt
  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    cipherText
  );

  // 5️⃣ Convert → JSON
  return JSON.parse(new TextDecoder().decode(decryptedBuffer));
}
